import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, withKeys as _withKeys, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/img/login_logo2.png';
import _imports_1 from '@/assets/img/login_title.png';
const _hoisted_1 = {
  class: "login-form"
};
const _hoisted_2 = {
  class: "login-box"
};
const _hoisted_3 = {
  class: "img-box"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "login-input"
};
const _hoisted_6 = {
  class: "mode-switch"
};
const _hoisted_7 = {
  style: {
    "display": "flex",
    "justify-content": "center",
    "align-items": "center",
    "cursor": "pointer",
    "height": "100%",
    "margin-right": "10px"
  }
};
const _hoisted_8 = ["src"];
const _hoisted_9 = {
  key: 0,
  class: "input-error"
};
const _hoisted_10 = {
  style: {
    "margin-top": "6px",
    "font-size": "12px",
    "color": "#999"
  }
};
const _hoisted_11 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "gap": "8px"
  }
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "justify-content": "flex-end",
    "gap": "8px"
  }
};
import { ElMessage } from 'element-plus';
import { useRouter } from 'vue-router';
import { encrypt, setToken, treeDataTranslate } from '@/common/utils/index';
import { useLoginStore, useLayoutStore } from '@/store';
import LoginController from '@/api/system/LoginController';
import eyeOpen from '@/assets/img/eye_open.png';
import eyeClose from '@/assets/img/eye_close.png';

import { onMounted, ref, computed, onBeforeUnmount, reactive } from 'vue';
// 使用项目内部资源图片
const SMS_COOLDOWN_SECONDS = 60;
const COOLDOWN_KEY = 'login_sms_cooldown_until';
const EXPIRE_KEY = 'login_sms_expire_until';
const puzzleW = 320;
const puzzleH = 160;
const pieceW = 40;
const pieceH = 40;
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const bkImg = require('@/assets/img/login_icon2.png');
    onMounted(() => {
      layoutStore.setMenuList([]);
      loginStore.setUserInfo({});
      setToken(null);
      // 恢复刷新前的倒计时（不缓存验证码有效期）
      const now = Date.now();
      const cooldownUntil = Number(localStorage.getItem(COOLDOWN_KEY) || 0);
      if (cooldownUntil > now) {
        const remaining = Math.ceil((cooldownUntil - now) / 1000);
        startCooldown(remaining);
      }
    });
    const loginForm = ref();
    const loginStore = useLoginStore();
    const layoutStore = useLayoutStore();
    const router = useRouter();
    const showPassword = ref(false);
    // 登录模式：password（账户密码）、sms（短信登录）、register（手机注册）
    const loginMode = ref('password');
    // 短信相关
    const sendingSms = ref(false);
    const smsCooldown = ref(0);
    let smsTimer = null;
    const smsExpireAt = ref(null);
    // 本地存储键与常量
    const smsRemainingText = computed(() => {
      if (!smsExpireAt.value) return '';
      const ms = smsExpireAt.value - Date.now();
      if (ms <= 0) return '已过期';
      const m = Math.floor(ms / 60000);
      const s = Math.floor(ms % 60000 / 1000);
      return `${m}分${s}秒`;
    });
    onBeforeUnmount(() => {
      if (smsTimer) {
        clearInterval(smsTimer);
        smsTimer = null;
      }
    });
    function startCooldown(seconds = 60) {
      smsCooldown.value = seconds;
      // 持久化倒计时结束时间
      localStorage.setItem(COOLDOWN_KEY, String(Date.now() + seconds * 1000));
      if (smsTimer) clearInterval(smsTimer);
      smsTimer = setInterval(() => {
        smsCooldown.value -= 1;
        if (smsCooldown.value <= 0) {
          clearInterval(smsTimer);
          smsTimer = null;
          // 倒计时结束清除本地记录
          localStorage.removeItem(COOLDOWN_KEY);
        }
      }, 1000);
    }
    function trimVal(v) {
      return (v ?? '').toString().trim();
    }
    function isValidMobile(mobile) {
      // 简单校验中国大陆手机号
      return /^1[3-9]\d{9}$/.test(mobile);
    }
    const captchaDialogVisible = ref(false);
    const captchaValue = ref(0);
    const captchaVerified = ref(false);
    const pendingMobileForSms = ref('');
    // 拼图参数
    const puzzleImgSrc = bkImg;
    const maxX = puzzleW - pieceW;
    const pieceY = ref(50);
    const targetX = ref(200);
    const currentX = computed(() => Math.round(captchaValue.value / 100 * maxX));
    function initPuzzle() {
      // 随机缺口位置与纵向位置，避免过近边缘
      pieceY.value = 20 + Math.floor(Math.random() * Math.max(1, puzzleH - pieceH - 40));
      targetX.value = 50 + Math.floor(Math.random() * Math.max(1, puzzleW - pieceW - 100));
      captchaValue.value = 0;
      captchaVerified.value = false;
    }
    function openCaptchaDialog(mobile) {
      captchaDialogVisible.value = true;
      initPuzzle();
      pendingMobileForSms.value = mobile;
    }
    function closeCaptchaDialog() {
      captchaDialogVisible.value = false;
    }
    function resetCaptcha() {
      initPuzzle();
    }
    function onCaptchaChange(val) {
      // 对齐判定：当前X接近目标X
      captchaVerified.value = Math.abs(currentX.value - targetX.value) <= 4;
    }
    function confirmCaptchaAndSend() {
      if (!captchaVerified.value) {
        ElMessage.warning('请先完成安全验证');
        return;
      }
      const mobile = trimVal(pendingMobileForSms.value || dataForm.mobilePhone);
      if (!mobile || !isValidMobile(mobile)) {
        ElMessage.warning('手机号校验失败，请重新输入');
        return;
      }
      doSendSms(mobile);
      closeCaptchaDialog();
    }
    // 拆分实际发送逻辑，供验证通过后调用
    function doSendSms(mobile) {
      if (smsCooldown.value > 0) return;
      sendingSms.value = true;
      LoginController.sendSmsCode({
        mobile: mobile
      }).then(() => {
        ElMessage.success('验证码已发送，5分钟内有效');
        smsExpireAt.value = Date.now() + 5 * 60 * 1000;
        // 不缓存验证码有效期，仅持久化倒计时
        startCooldown(SMS_COOLDOWN_SECONDS);
      }).catch(e => {
        console.error(e);
        ElMessage.error('发送验证码失败');
      }).finally(() => {
        sendingSms.value = false;
      });
    }
    // 修改触发：点击获取验证码时先做安全验证
    const onSendSms = () => {
      const mobile = trimVal(dataForm.mobilePhone);
      if (!mobile) {
        ElMessage.warning('请输入手机号');
        return;
      }
      if (!isValidMobile(mobile)) {
        ElMessage.warning('手机号格式不正确');
        return;
      }
      if (smsCooldown.value > 0) return;
      openCaptchaDialog(mobile);
    };
    const dataForm = reactive({
      loginName: '',
      mobilePhone: '',
      password: '',
      confirmPassword: '',
      smsCode: ''
    });
    const dataFormSubmit = () => {
      if (loginMode.value === 'password') {
        loginByPassword();
        return;
      }
      const mobile = trimVal(dataForm.mobilePhone);
      const sms = trimVal(dataForm.smsCode);
      if (!mobile) {
        ElMessage.warning('请输入手机号');
        return;
      }
      if (!isValidMobile(mobile)) {
        ElMessage.warning('手机号格式不正确');
        return;
      }
      if (!sms) {
        ElMessage.warning('请输入短信验证码');
        return;
      }
      if (smsExpireAt.value && Date.now() > smsExpireAt.value) {
        ElMessage.warning('验证码已过期，请重新获取');
        return;
      }
      if (loginMode.value === 'sms') {
        loginBySms(mobile, sms);
      } else if (loginMode.value === 'register') {
        const pwd = trimVal(dataForm.password);
        const confirmPwd = trimVal(dataForm.confirmPassword);
        if (!pwd) {
          confirmPwdError.value = '请设置密码';
          ElMessage.warning('请设置密码');
          return;
        }
        if (!confirmPwd) {
          confirmPwdError.value = '请确认密码';
          ElMessage.warning('请确认密码');
          return;
        }
        if (pwd !== confirmPwd) {
          confirmPwdError.value = '两次输入的密码不一致';
          ElMessage.error('两次输入的密码不一致');
          return;
        }
        confirmPwdError.value = '';
        registerByMobile(mobile, sms, pwd);
      }
    };
    function handleLoginSuccess(data) {
      if (data.data.menuList) {
        layoutStore.setMenuList(treeDataTranslate(data.data.menuList, 'menuId', 'parentId'));
        delete data.data.menuList;
      }
      setToken(data.data.tokenData);
      layoutStore.setCurrentMenu(null);
      layoutStore.clearAllTags();
      if (data.data.tokenData) {
        delete data.data.tokenData;
      }
      loginStore.setUserInfo(data.data);
      router.replace({
        name: 'main'
      });
    }
    const loginByPassword = function (verifyParams = null) {
      const loginName = trimVal(dataForm.loginName);
      const pwd = trimVal(dataForm.password);
      if (!loginName) {
        ElMessage.warning('请输入帐号');
        return;
      }
      if (!pwd) {
        ElMessage.warning('请输入密码');
        return;
      }
      const params = {
        loginName,
        password: encrypt(pwd)
      };
      if (verifyParams?.captchaVerification) {
        params.captchaVerification = verifyParams.captchaVerification;
      }
      setToken(null);
      LoginController.login(params).then(data => {
        handleLoginSuccess(data);
      }).catch(e => {
        console.error(e);
      });
    };
    const loginBySms = function (mobile, sms) {
      const mobilePhone = mobile ?? trimVal(dataForm.mobilePhone);
      const smsCode = sms ?? trimVal(dataForm.smsCode);
      setToken(null);
      LoginController.mobileLogin({
        mobile: mobilePhone,
        smsCode
      }).then(data => {
        handleLoginSuccess(data);
      }).catch(e => {
        console.error(e);
      });
    };
    const registerByMobile = function (mobile, sms, pwd) {
      const mobilePhone = mobile ?? trimVal(dataForm.mobilePhone);
      const smsCode = sms ?? trimVal(dataForm.smsCode);
      const password = pwd ?? trimVal(dataForm.password);
      LoginController.mobileRegister({
        mobile: mobilePhone,
        smsCode,
        password: encrypt(password)
      }).then(() => {
        ElMessage.success('注册成功，正在登录');
        loginBySms(mobilePhone, smsCode);
      }).catch(e => {
        console.error(e);
      });
    };
    const confirmPwdError = ref('');
    function validateConfirmPwd() {
      const pwd = trimVal(dataForm.password);
      const confirmPwd = trimVal(dataForm.confirmPassword);
      if (!confirmPwd) {
        confirmPwdError.value = '请确认密码';
        return;
      }
      confirmPwdError.value = pwd === confirmPwd ? '' : '两次输入的密码不一致';
    }
    return (_ctx, _cache) => {
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_slider = _resolveComponent("el-slider");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[20] || (_cache[20] = _createElementVNode("div", {
        class: "logo-box logo-right"
      }, [_createElementVNode("img", {
        src: _imports_0,
        style: {
          "height": "80px"
        },
        alt: ""
      })], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[10] || (_cache[10] = _createElementVNode("img", {
        class: "img-title",
        style: {
          "height": "55px"
        },
        src: _imports_1,
        alt: ""
      }, null, -1)), _createElementVNode("img", {
        src: _unref(bkImg),
        style: {
          "flex-shrink": "0",
          "height": "100%"
        }
      }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_cache[19] || (_cache[19] = _createElementVNode("span", {
        class: "title"
      }, "欢迎登录", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_radio_group, {
        modelValue: _unref(loginMode),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(loginMode) ? loginMode.value = $event : null),
        size: "small"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_radio_button, {
          label: "password"
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("账户登录", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: "sms"
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("短信登录", -1)]))]),
          _: 1
        }), _createVNode(_component_el_radio_button, {
          label: "register"
        }, {
          default: _withCtx(() => [...(_cache[13] || (_cache[13] = [_createTextVNode("立即注册", -1)]))]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]), _createVNode(_component_el_form, {
        model: _unref(dataForm),
        "label-position": "top",
        ref_key: "loginForm",
        ref: loginForm,
        onKeyup: _withKeys(_withModifiers(() => {}, ["stop"]), ["enter"])
      }, {
        default: _withCtx(() => [_unref(loginMode) === 'password' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 0,
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "",
            style: {
              "margin-top": "24px",
              "margin-bottom": "16px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).loginName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _unref(dataForm).loginName = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              placeholder: "请输入帐号或手机号码"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })) : (_openBlock(), _createBlock(_component_el_col, {
          key: 1,
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "",
            style: {
              "margin-top": "24px",
              "margin-bottom": "16px"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).mobilePhone,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(dataForm).mobilePhone = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              placeholder: "请输入手机号"
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        })), _unref(loginMode) === 'password' || _unref(loginMode) === 'register' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 2,
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).password,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(dataForm).password = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              type: _unref(showPassword) ? 'text' : 'password',
              placeholder: "请输入密码"
            }, {
              suffix: _withCtx(() => [_createElementVNode("i", _hoisted_7, [_createElementVNode("img", {
                src: !_unref(showPassword) ? _unref(eyeClose) : _unref(eyeOpen),
                style: {
                  "width": "24px"
                },
                onClick: _cache[3] || (_cache[3] = $event => showPassword.value = !_unref(showPassword))
              }, null, 8, _hoisted_8)])]),
              _: 1
            }, 8, ["modelValue", "type"])]),
            _: 1
          }), _unref(loginMode) === 'register' ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).confirmPassword,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => _unref(dataForm).confirmPassword = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              type: 'password',
              placeholder: "请再次输入密码确认",
              onBlur: validateConfirmPwd
            }, null, 8, ["modelValue"]), _unref(confirmPwdError) ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(confirmPwdError)), 1)) : _createCommentVNode("", true)]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        })) : _createCommentVNode("", true), _unref(loginMode) !== 'password' ? (_openBlock(), _createBlock(_component_el_col, {
          key: 3,
          span: 24
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: ""
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: _unref(dataForm).smsCode,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => _unref(dataForm).smsCode = $event),
              style: {
                "width": "100%",
                "height": "50px"
              },
              placeholder: "请输入短信验证码"
            }, {
              suffix: _withCtx(() => [_createVNode(_component_el_button, {
                type: "primary",
                size: "small",
                disabled: _unref(smsCooldown) > 0 || _unref(sendingSms),
                onClick: onSendSms
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(smsCooldown) > 0 ? `${_unref(smsCooldown)}s后可重新获取` : '获取验证码'), 1)]),
                _: 1
              }, 8, ["disabled"])]),
              _: 1
            }, 8, ["modelValue"]), _createElementVNode("div", _hoisted_10, " 验证码5分钟内有效" + _toDisplayString(_unref(smsExpireAt) ? `（剩余 ${_unref(smsRemainingText)}）` : ''), 1)]),
            _: 1
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_button, {
          class: "login-btn-submit",
          type: "primary",
          size: "large",
          onClick: _cache[7] || (_cache[7] = $event => dataFormSubmit()),
          style: {
            "width": "100%",
            "height": "50px",
            "margin-top": "16px",
            "font-size": "16px"
          }
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(loginMode) === 'password' ? '登录' : _unref(loginMode) === 'sms' ? '短信登录' : '注册并登录'), 1)]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "onKeyup"]), _createVNode(_component_el_dialog, {
        modelValue: _unref(captchaDialogVisible),
        "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => _isRef(captchaDialogVisible) ? captchaDialogVisible.value = $event : null),
        title: "安全验证",
        width: "420px",
        "close-on-click-modal": false,
        "close-on-press-escape": false
      }, {
        footer: _withCtx(() => [_createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          onClick: closeCaptchaDialog
        }, {
          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          disabled: !_unref(captchaVerified),
          onClick: confirmCaptchaAndSend
        }, {
          default: _withCtx(() => [...(_cache[17] || (_cache[17] = [_createTextVNode("验证通过，发送验证码", -1)]))]),
          _: 1
        }, 8, ["disabled"])])]),
        default: _withCtx(() => [_createElementVNode("div", {
          class: "captcha-puzzle-container",
          style: _normalizeStyle({
            backgroundImage: `url(${_unref(puzzleImgSrc)})`
          })
        }, [_cache[14] || (_cache[14] = _createElementVNode("div", {
          class: "captcha-overlay"
        }, null, -1)), _createElementVNode("div", {
          class: "captcha-hole",
          style: _normalizeStyle({
            left: _unref(targetX) + 'px',
            top: _unref(pieceY) + 'px',
            width: pieceW + 'px',
            height: pieceH + 'px',
            backgroundImage: `url(${_unref(puzzleImgSrc)})`,
            backgroundPosition: `-${_unref(targetX)}px -${_unref(pieceY)}px`
          })
        }, null, 4), _createElementVNode("div", {
          class: "captcha-piece",
          style: _normalizeStyle({
            left: _unref(currentX) + 'px',
            top: _unref(pieceY) + 'px',
            width: pieceW + 'px',
            height: pieceH + 'px',
            backgroundImage: `url(${_unref(puzzleImgSrc)})`,
            backgroundPosition: `-${_unref(targetX)}px -${_unref(pieceY)}px`
          })
        }, null, 4)], 4), _cache[18] || (_cache[18] = _createElementVNode("div", {
          style: {
            "padding": "8px 0",
            "color": "#666"
          }
        }, "请拖动滑块使拼图块与缺口对齐", -1)), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_slider, {
          modelValue: _unref(captchaValue),
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => _isRef(captchaValue) ? captchaValue.value = $event : null),
          min: 0,
          max: 100,
          step: 1,
          style: {
            "flex": "1"
          },
          onInput: onCaptchaChange
        }, null, 8, ["modelValue"]), _createVNode(_component_el_button, {
          size: "small",
          onClick: resetCaptcha
        }, {
          default: _withCtx(() => [...(_cache[15] || (_cache[15] = [_createTextVNode("重试", -1)]))]),
          _: 1
        })]), _createElementVNode("div", {
          style: _normalizeStyle({
            marginTop: '8px',
            fontSize: '12px',
            color: _unref(captchaVerified) ? '#67C23A' : '#F56C6C'
          })
        }, _toDisplayString(_unref(captchaVerified) ? '验证通过' : '请将滑块拖动，使拼图块对齐缺口'), 5)]),
        _: 1
      }, 8, ["modelValue"])])]), _cache[21] || (_cache[21] = _createElementVNode("div", {
        style: {
          "position": "absolute",
          "right": "0",
          "bottom": "0",
          "left": "0",
          "height": "44px",
          "font-size": "14px",
          "color": "#666",
          "background-color": "#f7fafe"
        }
      }, [_createElementVNode("p", {
        style: {
          "padding": "0",
          "margin": "0",
          "text-align": "center",
          "line-height": "44px"
        }
      }, " 广西瑞星光投资有限公司 桂ICP备2023011438号-3 ")], -1))]);
    };
  }
});